import './rate.scss';
import { useContext } from 'react';
// Assets
import { ReactComponent as RateIcon } from '../../assets/rateus.svg';

import { StateContext } from '../../contexts/state';

// Services
import messenger from '../../services/messenger';

const Rate = () => {
	const {
		data: { feedbackLink },
	} = useContext(StateContext);


	function onClick() {
		messenger.log({ eventAction: 'Rate Us' });
		window.open(feedbackLink, '_blank');
	}

	return (
		<div className='rate' onClick={onClick}>
			Rate Us
		</div>
	);
};

export default Rate;
